import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import _ from 'lodash';
import moment from 'moment';
import { getDataFromAPI } from '../HandleAPICalls/actions';
import LVMBMVID from './component';

class ListVMByVariantIdContainer extends Component {
  constructor() {
    super();
    this.state = {
      list: [],
      product: null,
      vmIds: [],
      loading: true,
      openModal: false,
      expiryDateTime: moment().add(7, 'd')
    };
  }

  componentDidMount() {
    const { productId } = this.props.match.params;

    this.props.getDataFromAPI(
      `/mvs/vendingmachines?mvId=${productId}`,
      'GET',
      undefined,
      response => {
        // console.log(response);
        this.setState((prevState, props) => ({
          loading: false,
          list: response.vmList,
          product: response.productDetails
        }));
      },
      err => {
        this.setState((prevState, props) => ({
          loading: false
        }));
        toastr.error('ERROR', err);
        console.log(err);
      }
    );
  }

  onChangeOfCheckbox = vmId => {
    // if vmId is aready present, remove it
    if (this.state.vmIds.includes(vmId)) {
      const ids = this.state.vmIds.filter(id => id !== vmId);
      this.setState({
        vmIds: ids
      });
    } else {
      this.setState({
        vmIds: [...this.state.vmIds, vmId]
      });
    }
  };

  onClickOfExpireSelected = () => {
    if (!this.state.vmIds.length) {
      return toastr.warning('Warning', 'Select VMs to schedule expiry');
    }
    if (!confirm(`Are you sure to expire this product in VM Id: ${this.state.vmIds.join()}?`)) {
      return;
    }
    this.setState({
      loading: true
    });

    if (!this.state.vmIds.length) {
      this.setState({
        loading: false
      });
      return toastr.warning('Invalid', 'No VMs Selected');
    }

    const payload = {
      mvId: this.state.product.id,
      vmId: this.state.vmIds
    };

    this.props.getDataFromAPI(
      '/mvs/vendingmachines/expire',
      'POST',
      payload,
      response => {
        toastr.success('Successful', 'Expired product in selected VMs');
        return this.props.history.push('/products');
      },
      err => {
        this.setState({
          loading: false,
          vmIds: []
        });
        toastr.error('Failed', 'Expiry operation failed');
      }
    );
  };

  onClickOfExpireAll = () => {
    if (!confirm('Are you sure to expire this product in all VMs?')) {
      return;
    }

    this.setState({
      loading: true
    });

    if (!this.state.list.length) {
      if (!confirm('Are you sure to expire this product in all the VMs?')) {
        return;
      }
      this.setState({
        loading: false
      });
      return toastr.error('Invalid', 'No VMs');
    }

    // select unique vending machines
    const vmIds = this.state.list.map(el => el.vending_machine_id).filter((elem, pos, arr) => {
      return arr.indexOf(elem) == pos;
    });

    const payload = {
      mvId: this.state.product.id,
      vmId: vmIds
    };

    this.props.getDataFromAPI(
      '/mvs/vendingmachines/expire',
      'POST',
      payload,
      response => {
        toastr.success('Successful', 'Expired product in selected VMs');
        return this.props.history.push('/products');
      },
      err => {
        this.setState({
          loading: false,
          vmIds: []
        });
        toastr.error('Failed', 'Expiry operation failed');
      }
    );
  };

  onClickOfScheduleExpiry = () => {
    if (!this.state.vmIds.length) {
      return toastr.warning('Warning', 'Select VMs to schedule expiry');
    }
    this.setState({
      openModal: true
    });
  };

  onClickOfModalCancel = () => {
    this.setState({
      openModal: false
    });
  };

  onChangeOfExpiryDate = date => {
    this.setState({
      expiryDateTime: moment(date)
    });
  };

  onClickOfScheduleInModal = () => {
    if (!confirm(`Are you sure to expire this product in VM Id: ${this.state.vmIds.join()}?`)) {
      return;
    }
    this.setState({
      loading: true
    });

    if (!this.state.vmIds.length) {
      this.setState({
        loading: false
      });
      return toastr.warning('Invalid', 'No VMs Selected');
    }

    const payload = {
      timestamp: this.state.expiryDateTime.utc().format('YYYY-MM-DD HH:mm:ss'),
      mvId: this.state.product.id,
      vmId: this.state.vmIds
    };

    this.props.getDataFromAPI(
      '/mvs/vendingmachines/expire/scheduled',
      'POST',
      payload,
      response => {
        toastr.success('Successful', 'Scheduled expiry product in selected VMs');
        return this.props.history.push('/products');
      },
      err => {
        this.setState({
          loading: false,
          vmIds: []
        });
        toastr.error('Failed', 'Scheduled expiry operation failed');
      }
    );
  };

  render() {
    // console.log('vm list from api ----------> ', this.state.list);
    // console.log('vm list for expiry ----------> ', this.state.vmIds);
    // console.log('state ----------> ', this.state);

    let totalCountOfProduct = 0;
    if (this.state.list.length) {
      totalCountOfProduct = this.state.list
        .map(el => el.active_count)
        .reduce((total, num) => total + num);
    }
    return (
      <LVMBMVID
        list={_.uniqBy(this.state.list, 'vending_machine_id')}
        product={this.state.product}
        loading={this.state.loading}
        onSelect={this.onChangeOfCheckbox}
        slectedVMs={this.state.vmIds.length}
        onExpireAll={this.onClickOfExpireAll}
        onExpireSelected={this.onClickOfExpireSelected}
        totalCountOfProduct={totalCountOfProduct}
        openModal={this.state.openModal}
        closeModal={this.onClickOfModalCancel}
        onScheduleExpiry={this.onClickOfScheduleExpiry}
        expiryDateTime={this.state.expiryDateTime}
        onChangeOfExpiryDate={this.onChangeOfExpiryDate}
        onClickOfScheduleInModal={this.onClickOfScheduleInModal}
      />
    );
  }
}

export default connect(null, { getDataFromAPI })(ListVMByVariantIdContainer);



// WEBPACK FOOTER //
// ./src/Modules/ListVMForVariantID/container.jsx